import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
import Swal from 'sweetalert2'
const Success = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const orderId = localStorage.getItem("orderId");
  const [show, setShow] = useState(false);
  const [email,setEmail] = useState('')
  const handlePrint = () => {
    window.print();
  };

  const [data, setData] = useState({});
  const today = new Date().toLocaleString();



  useEffect(() => {
    axios
      .get(`https://myshops.az/api/payment.php?orderId=${orderId}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [orderId]);
  // Telefon regex-i
  const phoneRegex = /994-\d{2}-\d{3}-\d{2}-\d{2}/;

  // Nömrəni tapırıq
  const phone = data?.CustomerName?.match(phoneRegex)?.[0] || "";

  // Ad hissəsini tapırıq (nömrəni çıxarırıq)
  const name = data?.CustomerName?.replace(phoneRegex, "").trim();


  const handleSubmit=(e)=>{
    e.preventDefault() ;
    Swal.fire({
      position: "top-center",
      icon: "success",
      title: `${t.successepoct}`,
      showConfirmButton: false,
      timer: 1500
    });
  }
 

  return (
    <>
      {data && (
        <div className="receipt-page">
          <div className="receipt-card">
            {/* <p className="bg-danger text-center p-2 rounded text-white ">
            Xidmət hal-hazırda beta mərhələsindədir.
            </p> */}
            <div className="receipt-header">
              <h2>{t.qebz1}</h2>
              <p className="muted">{t.borcMelumati}</p>
            </div>

            <div className="receipt-meta">
              <div>
                <span className="muted">{t.customerCode}</span>
                <strong>{data.CustomerCode}</strong>
              </div>
              <div>
                <span className="muted">{t.sifarisKodu}</span>
                <strong>{orderId && orderId}</strong>
              </div>
              <div>
                <span className="muted">{t.tarix}</span>
                <strong>{data.CreatedAt}</strong>
              </div>
            </div>

            <div className="receipt-body">
              <div className="line between">
                <span>{t.saa}</span>
                <span>{name}</span>
              </div>
              <div className="line between">
                <span>{t.mobil}</span>
                <span>{phone}</span>
              </div>
              <div className="line between">
                <span>{t.fin}</span>
                <span>{data.FIN}</span>
              </div>
              <div className="line between">
                <span>{t.muqavile}</span>
                <span>{data.ContractNumber}</span>
              </div>

              <div className="divider soft" />
              <div className="line between">
                <span className="muted">{t.odenildi}</span>
                <span className="muted">{data.Amount} ₼</span>
              </div>
              {/* <div className="line between total">
                <strong>{t.qaliqborc}</strong>
                <strong style={{ color: "red" }}>{data.total_debt} ₼</strong>
              </div> */}
            </div>

            <div className="receipt-footer">
              <p className="muted small">{t.odenisUsulu}</p>
              <p className="muted small">{t.thankPage}</p>
              <button className="print-btn no-print" onClick={handlePrint}>
                {t.print}
              </button>
              <button
                className="print-btn no-print"
                onClick={() => setShow(!show)}
              >
                {t.qebz}
              </button>
              <div className={`email-input-wrapper ${show ? "active" : ""}`}>
                <form 
                onSubmit={handleSubmit}
                >
                <input
                  type="email"
                  required
                  className="email-input"
                  placeholder={t.epoctunvan}
                  onChange={(e)=>{
                    const value = e.target.value ;
                    setEmail(value)
                  }}
                  
                />
                <button className="emailBtn" type="submit">{t.gonder}</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Success;
